export const FILTER_PAGE_ALL_EVENT = 'FILTER_PAGE_ALL_EVENT'
